import { gql, TypedDocumentNode } from '@apollo/client';

import {
  HighestEndReadingConnection,
  MaterialEntriesConnection,
  MaterialEntriesConnectionInput,
  MaterialEntry,
  MaterialEntryCreateInput,
  MaterialEntryUpdate,
} from '@atom/types/materialEntry';

export const BASE_MATERIAL_ENTRY = gql`
  fragment BaseMaterialEntry on MaterialEntry {
    id
    workOrderId
    taskId
    assetId
    userId
    user {
      firstName
      lastName
    }
    date
    amount
    startReading
    endReading
    createdBy {
      firstName
      lastName
    }
    updatedBy {
      firstName
      lastName
    }
    createdDate
    updatedDate
  }
`;

export const GET_MATERIAL_ENTRIES: TypedDocumentNode<
  { materialEntries: MaterialEntriesConnection },
  { input: MaterialEntriesConnectionInput }
> = gql`
  query materialEntries($input: MaterialEntriesConnectionInput!) {
    materialEntries(input: $input) {
      totalCount
      materialEntries {
        ...BaseMaterialEntry
      }
    }
  }
  ${BASE_MATERIAL_ENTRY}
`;

export const MATERIAL_ENTRY_CREATE: TypedDocumentNode<
  { materialEntryCreate: MaterialEntry },
  { input: MaterialEntryCreateInput }
> = gql`
  mutation materialEntryCreate($input: MaterialEntryCreateInput!) {
    materialEntryCreate(input: $input) {
      ...BaseMaterialEntry
    }
  }
  ${BASE_MATERIAL_ENTRY}
`;

export const MATERIAL_ENTRY_UPDATE: TypedDocumentNode<
  { materialEntryUpdate: MaterialEntry },
  { input: MaterialEntryUpdate }
> = gql`
  mutation materialEntryUpdate($input: MaterialEntryUpdate!) {
    materialEntryUpdate(input: $input) {
      ...BaseMaterialEntry
    }
  }
  ${BASE_MATERIAL_ENTRY}
`;

export const MATERIAL_ENTRY_DELETE: TypedDocumentNode<
  { materialEntryDelete: boolean },
  { id: string }
> = gql`
  mutation materialEntryDelete($id: ID!) {
    materialEntryDelete(id: $id)
  }
`;

export const GET_HIGHEST_END_READING: TypedDocumentNode<
  HighestEndReadingConnection,
  { input: MaterialEntriesConnectionInput }
> = gql`
  query highestEndReading($input: MaterialEntriesConnectionInput!) {
    highestEndReading(input: $input)
  }
`;
